import useQueueStateHandler from '../useQueueStateHandler'
import EmailFilingToastContent from '../../components/Toast/EmailFilingToastContent'
import * as React from 'react'

export type EmailFilingParams = {
    state?: string
    messageId: string
    userEmail: string
    notificationEmail: string
    hostKey: string
    references: string[]
}

export default function useEmailFilingHandler() {
    return useQueueStateHandler<EmailFilingParams>(props => <EmailFilingToastContent {...props} />)
}
